<template>
  <div class="learn-process">
    <div
      class="learn-process__excercise position-rel mt-43 border-css"
      v-if="isHideTable"
    >
      <div class="title">
        <h2 class="font-sanpro-semibold font-size-24 primary-color-txt">
          Quá trình luyện tập
        </h2>
      </div>

      <div class="target" v-if="getProcessPracticeChart.trophy < 30">
        <img src="@/assets/images/blank.svg" alt />
        <h3
          class="font-size-16 font-sanpro-semibold primary-color-txt target-name text-center"
        >
          Chưa có huy chương
        </h3>
      </div>
      <div
        class="target"
        v-else-if="
          getProcessPracticeChart.trophy >= 30 &&
          getProcessPracticeChart.trophy < 60
        "
      >
        <img src="@/assets/images/copper.svg" alt />
        <h3
          class="font-size-16 font-sanpro-semibold primary-color-txt target-name text-center"
        >
          Danh hiệu đồng
        </h3>
      </div>
      <div
        class="target"
        v-else-if="
          getProcessPracticeChart.trophy >= 60 &&
          getProcessPracticeChart.trophy < 90
        "
      >
        <img src="@/assets/images/silver.svg" alt />

        <h3
          class="font-size-16 font-sanpro-semibold primary-color-txt target-name text-center"
        >
          Danh hiệu bạc
        </h3>
      </div>
      <div class="target" v-else-if="getProcessPracticeChart.trophy >= 90">
        <img src="@/assets/images/gold.svg" alt />
        <h3
          class="font-size-16 font-sanpro-semibold primary-color-txt target-name text-center"
        >
          Danh hiệu vàng
        </h3>
      </div>
      <div class="all-select display-flex">
        <div class="practice-to-book select-custom selectdiv position-rel">
          <select class="form-control" id="status" @change="changeSelect">
            <option
              v-for="(item, index) of dataTypePractice"
              :key="index"
              :value="item.practiceTypeId"
            >
              {{ item.name }}
            </option>
          </select>
          <i class="fa fa-angle-down"></i>
        </div>
        <div
          class="practice-to-book select-custom selectdiv position-rel"
          v-if="dataBookGroup && dataBookGroup.length > 1  "
        >
          <select
            class="form-control"
            id="status"
            @change="changePractice"
            name="practiceTypeId"
          >
            <option
              v-for="(item, index) of dataBookGroup"
              :key="index"
              :value="item.practiceTypeId"
            >
              {{ item.name }}
            </option>
          </select>
          <i class="fa fa-angle-down"></i>
        </div>
        <div class="practice-to-book select-custom selectdiv position-rel">
          <select
            class="form-control"
            id="status"
            @change="changePractice"
            name="subjectId"
          >
            <option value="0">Môn - Tất cả</option>
            <option
              v-for="(item, index) of dataSubject"
              :key="index"
              :value="item.subjectId"
            >
              {{ item.name }}
            </option>
          </select>
          <i class="fa fa-angle-down"></i>
        </div>
      </div>
      <div class="result display-flex justify-content-between">
        <div class="question-done">
          <label
            for
            class="font-size-16 font-sanpro-semibold secondary-color-txt"
            >Số câu đã làm</label
          >
          <br />
          <span class="primary-color-txt font-sanpro font-size-16"
            >{{ getProcessPracticeChart.totalQuestionDone }} /
            {{ getProcessPracticeChart.totalQuestion }}</span
          >
        </div>
        <div class="question-correct">
          <label
            for
            class="font-size-16 font-sanpro-semibold secondary-color-txt"
            >Số câu đúng</label
          >
          <br />
          <span class="primary-color-txt font-sanpro font-size-16"
            >{{ getProcessPracticeChart.totalQuestionCorrect }} /
            {{ getProcessPracticeChart.totalQuestion }}</span
          >
        </div>
        <div class="question-wrong">
          <label
            for
            class="font-size-16 font-sanpro-semibold secondary-color-txt"
            >Số câu sai</label
          >
          <br />
          <span class="primary-color-txt font-sanpro font-size-16"
            >{{ getProcessPracticeChart.totalQuestionInCorrect }} /
            {{ getProcessPracticeChart.totalQuestion }}</span
          >
        </div>
      </div>

      <div class="score-chart position-rel">
        <div class="bg">
          <img src="@/assets/img/bg-profile.png" class="bg-chart" alt />
        </div>
        <div
          class="student"
          :style="{
            left:
                getProcessPracticeChart.totalQuestion!==0?
              (getProcessPracticeChart.totalQuestionCorrect * 100) /
                getProcessPracticeChart.totalQuestion +
              '%':0+'%',
          }"
        >
          <h2
            class="font-size-16 font-sanpro-semibold primary-color-txt text-center"
          >
            {{ getProcessPracticeChart.totalQuestionDone }}
          </h2>
          <img src="@/assets/img/student-profile.png" class="img-student" alt />
        </div>
        <div class="flag">
          <h2
            class="font-size-16 font-sanpro-semibold primary-color-txt text-center"
          >
            {{ getProcessPracticeChart.totalQuestion }}
          </h2>
          <img src="@/assets/img/flag-profile.png" class="img-flag" alt />
        </div>
        <!-- <div class="line">
            <img src="@/assets/img/line-profile.png" class="img-line" alt="">
        </div>-->
          {{getProcessPracticeChart.totalQuestionInCorrect *100}}/ {{getProcessPracticeChart.totalQuestion}}
        <div class="progress line" style>
        
          <div
            class="progress-bar"
            :style="{
              width:
                 getProcessPracticeChart.totalQuestion!==0?
                (getProcessPracticeChart.totalQuestionCorrect * 100) /
                  getProcessPracticeChart.totalQuestion +
                '%':0+'%',
              background: ' #5fcea1',
            }"
          ></div>
          <div
            class="progress-bar"
            :style="{
              width:
                getProcessPracticeChart.totalQuestion!==0?
                getProcessPracticeChart.totalQuestionInCorrect * 100 /
                  getProcessPracticeChart.totalQuestion +
                '%':0+'%',
              background: '#f46055',
            }"
          ></div>
        </div>
      </div>
    </div>
    <div class="learn-process__study mt-43 border-css" v-if="isHideTable">
      <div class="title display-flex justify-content-between">
        <h2 class="font-sanpro-semibold font-size-24 primary-color-txt">
          Quá trình học tập
        </h2>
        <h3
          class="primary-color font-size-16 font-sanpro-semibold cursor-pointer"
          @click="handleShowTableStatitic"
        >
          Bảng thống kê chi tiết
        </h3>
      </div>
      <div class="all-select display-flex">
        <div class="practice-to-book select-custom selectdiv position-rel">
          <select
            class="form-control"
            id="status"
            @change="hadelChangeSelect"
            name="type"
          >
            <option
              v-for="(item, index) of dataBookpractice"
              :key="index"
              :value="item.type"
            >
              {{ item.name }}
            </option>
          </select>
          <i class="fa fa-angle-down"></i>
        </div>
        <div class="practice-to-book select-custom selectdiv position-rel">
          <select
            class="form-control"
            id="status"
            @change="hadelChangeSelect"
            name="subjectId"
          >
            <option value="0">Môn - Tất cả</option>
            <option
              v-for="(item, index) of dataSubject"
              :key="index"
              :value="item.subjectId"
            >
              {{ item.name }}
            </option>
          </select>
          <i class="fa fa-angle-down"></i>
        </div>
        <div class="practice-to-book select-custom selectdiv position-rel">
          <select
            class="form-control"
            id="status"
            @change="hadelChangeSelect"
            name="timeType"
          >
            <option
              v-for="(item, index) of dataTime"
              :key="index"
              :value="item.timeType"
            >
              {{ item.name }}
            </option>
          </select>
          <i class="fa fa-angle-down"></i>
        </div>
      </div>
      <div class="line-chart">
        <div id="chart" style="position: relative;">
          <apexchart
            type="line"
            height="350"
            :options="chartOptions"
            :series="series"
          >

          </apexchart>
         
        </div>
      </div>
       <!-- <b-modal id="modal">Hello From Modal!</b-modal> -->
  
    </div>
    <div class="learn-process__overview mt-43 border-css" v-if="isHideTable">
      <div class="title">
        <h2 class="font-sanpro-semibold font-size-24 primary-color-txt">
          Tổng quan các môn học
        </h2>
      </div>
      <div class="chart">
        <div id="chart">
          <apexchart
            type="bar"
            height="350"
            :options="chartOptionsBar"
            :series="seriesBar"
          ></apexchart>
         
        </div>
      </div>
    </div>
    <!-- <div class="tuntime">
      <v-runtime-template v-if="template" :template="template" />
    </div> -->
      <div  class="arrow_box" :style="{ left: clientX, top:clientY }" v-if="dateandtime !=='Invalid date' && modalShow">
           <span class=" font-sanpro-semibold font-size-16  secondary-color-txt cursor-pointer ml-2 mt-2 mb-2 display-block full-width">
              {{dateandtime}}
            </span>
            <div class="item" v-if="dataByDay && dataByDay.length >0" v-for="(item,index) of dataByDay " :key="index"> 
                  <a href="javascript:;" class="primary-color font-size-16   font-sanpro-semibold  cursor-pointer ml-2 mt-2 display-block full-width"  @click="pageRote(item)">
                    {{item.name}}
                  </a>
                  <!-- <span class="primary-color-txt font-sanpro font-size-14 ml-2 mb-2">
                    xxxxx
                  </span> -->
                <span class="primary-color-txt font-sanpro font-size-14 ml-2 mb-2">
                    {{ hhmmss(item.timeToDo )}} 
                 </span>
                 <span class="primary-color-txt font-sanpro font-size-14" v-if="paramLeaningProcess.type ===2"  >
                   - Làm đúng
                    {{item.totalQuestionCorrect }}/{{item.totalQuestionDone }}
                 </span>
            </div>
            <div class="item1 secondary-color-txt text-center" v-if=" dataByDay.length ===0">Chưa có hoạt động nào</div>
      </div>
        <DetailLearnProcess v-if="isShowTableStatistic" />
  </div>
       <!-- :style="{
            left:
                getProcessPracticeChart.totalQuestion!==0?
              (getProcessPracticeChart.totalQuestionCorrect * 100) /
                getProcessPracticeChart.totalQuestion +
              '%':0+'%',
          } -->
</template>

<script>
import VRuntimeTemplate from "v-runtime-template";
import { mapActions, mapState } from "vuex";
import { STORE_KEY,BY_YEAR,
  TYPE_ACTIVE_ACTIVITY,
  TYPE_READ_BOOK_ACTIVITY,
  TYPE_EXERCISE_ACTIVITY,
  TYPE_EXERCISE_ACTIVITY_EXAM,
  TYPE_EXERCISE_ACTIVITY_THEMATIC,
  TYPE_EXERCISE_ACTIVITY_OTHER
 } from "../../_store/constants";
import VueApexCharts from "vue-apexcharts";
import { apiGetDetailProcessLearningByDate } from "./../../_api";
import DetailLearnProcess from "./DetailLearnProcess";
import moment from "moment";
export default {
  name: "LearnProcess",
  data() {
    let self = this
    return {
      typeAcExam: TYPE_EXERCISE_ACTIVITY_EXAM,
      typeAcThematic: TYPE_EXERCISE_ACTIVITY_THEMATIC,
      typeAcExerciseOther: TYPE_EXERCISE_ACTIVITY_OTHER,
      dateandtime:"",
      clientX:0,
      clientY:0,
      modalShow: false,
      template:"",
      isShow:true,
      index:0,
      byYear: BY_YEAR,
      yesterday: null,
      dataListProcessChat: [],
      elmEndItem: null,
      pagingData: {},
      dataByDay: [],
      formatDate: "DD/MM/YYYY",
      formatMonth: "MM/YYYY",
      dataBookpractice: [
        { name: "Luyện tập", type: 2 },
        { name: "Đọc sách", type: 1 },
      ],
      dataTime: [
        { name: "Theo tuần", timeType: 1 },
        { name: "Theo tháng", timeType: 2 },
        { name: "Theo năm", timeType: 3 },
      ],
      practiceTypeId: 0,
      classId: 1,
      series: [
        {
          data: [],
        },
      ],
      chartOptions: {
        chart: {
          height: 370,
          type: "line",
          events: {
            click: function (chart, w, e) {
              self.showDetailChart(chart,e)
            },
          },
          zoom: {
            enabled: false,
          },
          dataLabels: {
            enabled: false,
          },
          stroke: {
            curve: "straight",
          },
          title: {
            text: "Product Trends by Month",
            align: "left",
          },
          grid: {
            row: {
              colors: ["#f3f3f3", "transparent"], // takes an array which will be repeated on columns
              opacity: 0.5,
            },
          },
        },
        markers: {
            size: 5,
            colors: undefined,
            strokeColors: '#fff',
            strokeWidth: 2,
            strokeOpacity: 0.9,
            strokeDashArray: 0,
            fillOpacity: 1,
            discrete: [],
            shape: "circle",
            radius: 2,
            offsetX: 0,
            offsetY: 0,
            onClick: undefined,
            onDblClick: undefined,
            showNullDataPoints: true,
            hover: {
              size: undefined,
              sizeOffset: 3
            }
        },
        yaxis: {
          title: {
           text: 'Câu',
           rotate: 0,
           offsetX: 25,
           offsetY: -160,
          },
          
          axisBorder: {
            show: true,
            color: "#78909C",
            offsetX: 0,
            offsetY: 0,
          },
          // min: 0
        },
        xaxis: {
          axisBorder: {
            show: true,
            color: "#78909C",
              height: 1,
          width: '100%',
            offsetX: 0,
            offsetY:0,
          },
          tickPlacement: 'between',
          // title: {
          // text: 'Thời gian',
          // rotate: 90,
          // offsetX: 0,
          // offsetY: 0,
    
          // },
          categories: [],
        },
       events: {
      // click: function(event, chartContext, config) {
      //  console.log('22222222222200000000000000')

      // },
        tooltip: {
          intersect: true,
          custom: function () {},
        },

    }
      },
      seriesBar: [
        {
          data: [],
          name: "Điểm",
        },
      ],
      chartOptionsBar: {
        chart: {
          height: 350,
          type: "bar",
        },
        colors: [
          "#3B6BDD",
          "#5FCEA1",
          "#FFCC66",
          "#F46055",
          "#3B6BDD",
          "#5FCEA1",
          "#FFCC66",
        ],
        plotOptions: {
          bar: {
            columnWidth: "20px",
            distributed: true,
          },
        },
        dataLabels: {
          enabled: false,
        },
        legend: {
          show: false,
        },
        xaxis: {
          categories: [],
          labels: {
            style: {
              colors: [
                "#3B6BDD",
                "#5FCEA1",
                "#FFCC66",
                "#F46055",
                "#3B6BDD",
                "#5FCEA1",
                "#FFCC66",
              ],
              fontSize: "12px",
            },
          },
        },

        yaxis: {
          tickAmount: 10,
          min: 0,
          max: 10,
          axisBorder: {
            show: true,
            color: "#78909C",
            offsetX: 0,
            offsetY: 0,
          },
        },
      },
      isShowTableStatistic: false,
      isHideTable: true,
      
    };
  },
  computed: {
    ...mapState(STORE_KEY, [
      "dataTypePractice",
      "dataBookGroup",
      "getUserInfo",
      "dataSubject",
      "pramPracticeChart",
      "getProcessPracticeChart",
      "paramLeaningProcess",
      "dataListProcessLearing",
      "dataOverSubjectChart",
      "paramProcessChat",
      "displayDetail",
      'changeClass'
      // "dataListProcessChat"
    ]),
  },

  mounted() {
    this.getTypePractice();
    this.getSubjects();

    this.setParamListProcessChat({
      type: 2,
      classId: this.classId,
      subjectId: 0,
      practiceTypeId: 0,
      timeType: 1,
      keyword: "",
      pageIndex: 1,
      pageSize: 10,
      sort: "",
      direction: "",
    });
  },
  watch: {
    changeClass(){
  
    this.getTypePractice();
    this.getSubjects();
    this.setParamLearningProcess({
      type: 2,
      classId: this.classId,
      subjectId: 0,
      practiceTypeId: 0,
      timeType: 1,
    });
    this.setParamListProcessChat({
      type: 2,
      classId: this.classId,
      subjectId: 0,
      practiceTypeId: 0,
      timeType: 1,
      keyword: "",
      pageIndex: 1,
      pageSize: 10,
      sort: "",
      direction: "",
    });
      this.changeOverSubjectChart();
      this.handelDataListProcessLearing();
      this.changePramPracticeChart();
      this.changeParamLeaningProcess();
      this.getOverviewSubjectChart();
      this.getTypePractice();
      this.getSubjects();
      this.updateChartCss();
      this.updateChart1();
      this.practiceTypeId = this.dataTypePractice[0].practiceTypeId;
      this.actionGetBookGroup({
        practiceTypeId:  this.dataTypePractice[0].practiceTypeId,
      }).then((res) => {
        this.setPramPracticeChart({
          ...this.pramPracticeChart,
          classId: this.classId,
          subjectId: 0,
          practiceTypeId: res.data[0].practiceTypeId,
        });
      });
    },
    displayDetail() {
      if (this.isHideTable) {
        this.isHideTable = false;
      } else {
        this.isHideTable = true;
      }
      if (this.isShowTableStatistic) {
        this.isShowTableStatistic = false;
      } else {
        this.isShowTableStatistic = true;
      }
      this.changeOverSubjectChart();
      this.handelDataListProcessLearing();
      this.changePramPracticeChart();
      this.changeParamLeaningProcess();
      this.getOverviewSubjectChart();
      this.getTypePractice();
      this.getSubjects();
      this.updateChartCss();
      this.updateChart1();
    },
    getUserInfo(newVal) {
      this.classId = newVal.classId;
      this.setParamLearningProcess({
      type: 2,
      classId: this.classId,
      subjectId: 0,
      practiceTypeId: 0,
      timeType: 1,
    });
      this.getSubjects();
      this.getOverviewSubjectChart();
      // this.setPramPracticeChart({classId:this.classId,subjectId: 0,practiceTypeId:this.practiceTypeId})
    },
    dataTypePractice(newVal) {
      this.practiceTypeId = newVal[0].practiceTypeId;
      this.actionGetBookGroup({
        practiceTypeId: newVal[0].practiceTypeId,
      }).then((res) => {
        this.setPramPracticeChart({
          ...this.pramPracticeChart,
          classId: this.classId,
          subjectId: 0,
          practiceTypeId: res.data[0].practiceTypeId,
        });
      });
    },
    dataListProcessLearing: "handelDataListProcessLearing",
    pramPracticeChart: "changePramPracticeChart",
    paramLeaningProcess: "changeParamLeaningProcess",
    dataOverSubjectChart: "changeOverSubjectChart",
    // paramProcessChat:"changeParamProcessChat"
    // template (newVal) {
    //   setTimeout(() => {
    //     const elmItems = document.querySelectorAll('.item-test')
    //     const lengthItems = elmItems.length
    //     if (elmItems && lengthItems > 0) {
    //       for(let i = 0; i < lengthItems; i++) {
    //         elmItems[i].addEventListener('click', function(event) {
    //           console.log('AAAAAAAAAAAA', 'Cho Hoan')
    //         })  
    //       }
    //     }
    //   }, 1000)
    // }
  },
  components: {
    // VRuntimeTemplate,
    DetailLearnProcess,
    apexchart: VueApexCharts,
  },
  methods: {
    ...mapActions(STORE_KEY, [
      "updateUserProfile",
      "actionGetTypePractice",
      "actionGetBookGroup",
      "actionGetSubjects",
      "setPramPracticeChart",
      "actionGetProcessPracticeChart",
      "setParamLearningProcess",
      "actionGetListProcessLearning",
      "actionGetOverviewSubjectChart",
      "setParamListProcessChat",
      "actionGetListProcessChat",
      "actionGetDetailProcessLearningByDate",
    ]),
    moment,

    getTrainingPagination(value) {
      this.setParamListProcessChat({
        ...this.paramActivityList,
        pageIndex: value,
      });
    },

    changeSelect(e) {
      this.actionGetBookGroup({ practiceTypeId: e.target.value }).then(
        (res) => {
          if (parseInt(e.target.value) === 2 &&  this.classId ===1) {
            this.setPramPracticeChart({
              ...this.pramPracticeChart,
              practiceTypeId: res.data[0].practiceTypeId,
            });
          }
        }
      );
      if (parseInt(e.target.value) !== 2 || this.classId !==1) {
        this.setPramPracticeChart({
          ...this.pramPracticeChart,
          practiceTypeId: parseInt(e.target.value),
        });
      }
    },
    changePractice(e) {
      let name = e.target.name;
      this.setPramPracticeChart({
        ...this.pramPracticeChart,
        [name]: parseInt(e.target.value),
      });
    },
    hadelChangeSelect(e) {
      let name = e.target.name;
      this.setParamLearningProcess({
        ...this.paramLeaningProcess,
        [name]: parseInt(e.target.value),
      });
      this.setParamListProcessChat({
        ...this.paramProcessChat,
        [name]: parseInt(e.target.value),
      });
    },
    handelSelectChat(e) {
      let name = e.target.name;
      this.setParamListProcessChat({
        ...this.paramProcessChat,
        [name]: parseInt(e.target.value),
      });
    },
    updateChart() {
      let max =null;
      if (
        this.dataListProcessLearing &&
        Array.isArray(this.dataListProcessLearing) &&
        this.dataListProcessLearing.length > 0
      ) {
        this.dataListProcessLearing.map((item) => {
          // this.chartOptions.xaxis.categories.push(
          //   moment(item.createAt).format(this.formatDate)
          // );
          if(max <parseInt(item.timeToDo)){
            max =parseInt(item.timeToDo)
          }
          //1 dọc sách 2 luyên t
          if (this.paramLeaningProcess.type == 1) {
            this.series[0].data.push(parseInt(item.timeToDo));
          } else {
            this.series[0].data.push(parseInt(item.totalQuestionCorrect));
          }
        });
      } else if (
        this.dataListProcessLearing &&
        this.dataListProcessLearing.list &&
        this.dataListProcessLearing.list.length > 0
      ) {
        this.dataListProcessLearing.list.map((item) => {
          if (this.paramLeaningProcess.type == 1) {
            this.series[0].data.push(parseInt(item.timeToDo));
          } else {
            this.series[0].data.push(parseInt(item.totalQuestionCorrect));
          }
        });
      }
      // if (max >0) {
        
      // }
      const newData = this.series[0].data;
      this.series = [
        {
          data: newData,
        },
      ];
    },
    updateChartCss() {
      this.chartOptionsBar.xaxis.categories = [];
      if (this.dataOverSubjectChart && this.dataOverSubjectChart.length > 0) {
        this.dataOverSubjectChart.map((item, index) => {
          this.chartOptionsBar.xaxis.categories.push(item.name);
        });
      }
      const newData = this.chartOptionsBar.xaxis.categories;
      this.chartOptionsBar = {
        plotOptions: {
          bar: {
            columnWidth: "20px",
          },
        },
        yaxis: {
          tickAmount: 10,
          min: 0,
          max: 10,
        },
        xaxis: {
          categories: newData,
        },
      };
    },
    updateChart1() {
      let self = this;
      let max = 0;
      this.chartOptions.xaxis.categories = [];
      if (
        this.dataListProcessLearing &&
        Array.isArray(this.dataListProcessLearing) &&
        this.dataListProcessLearing.length > 0
      ) {
        this.dataListProcessLearing.map((item) => {
          this.chartOptions.xaxis.categories.push(
           this.paramLeaningProcess.timeType===self.byYear? moment(item.createDate).format(this.formatMonth):  moment(item.createDate).format(this.formatDate)
          );
          if(max <parseInt(item.timeToDo)  && self.paramLeaningProcess.type ===1){
            max =parseInt(item.timeToDo)
          }else if(max <parseInt(item.totalQuestionCorrect) &&  self.paramLeaningProcess.type ===2){
            max =parseInt(item.totalQuestionCorrect)
          }
        });
      } else if (
        !Array.isArray(this.dataListProcessLearing) &&
        this.dataListProcessLearing &&
        this.dataListProcessLearing.list &&
        this.dataListProcessLearing.list.length > 0
      ) {
        this.dataListProcessLearing.list.map((item) => {
          this.chartOptions.xaxis.categories.push(
            this.paramLeaningProcess.timeType===self.byYear? moment(item.createDate).format(this.formatMonth):  moment(item.createDate).format(this.formatDate)
          );
        });
      }
      // console.log('2222222222222222222222222',max);
      // câu hỏi dưới 5 thì khoang cách == max
      if(max < 5){
        var  newData = max
      }
      const newData3 = this.chartOptions.xaxis.categories
      this.chartOptions = {
        chart: {
          events: {
            click: function (chart, w, e) {
              self.showDetailChart(chart,e)
            },
          },
        },
          title: {
            text: "Thời gian",
            align: "right",
            position: 'bottom',
             rotate: 45,
             offsetX: 0,
             offsetY: 333 ,
          },

        markers: {
            size: 5,
            colors: undefined,
            strokeColors: '#fff',
            strokeWidth: 2,
            strokeOpacity: 0.9,
            strokeDashArray: 0,
            fillOpacity: 1,
            discrete: [],
            shape: "circle",
            radius: 2,
            offsetX: 0,
            offsetY: 0,
            onClick: undefined,
            onDblClick: undefined,
            showNullDataPoints: true,
            hover: {
              size: undefined,
              sizeOffset: 3
            }
        },

        yaxis: {
           position: 'top',
          labels:{
            formatter: (value) => { return value },
          },
          title: {
            text: self.paramLeaningProcess.type ===1? 'Phút':'Câu',
            rotate: 0,
            offsetX: 25,
            offsetY: -160,
          },
      
          forceNiceScale: true,
          decimalsInFloat:0,
          max : newData,
          tickAmount: newData,
          axisBorder: {
            show: true,
            color: "#78909C",
            offsetX: 0,
            offsetY: 0,
          },
        },
        xaxis: {
          // position: 'right',
            align: 'left',
          tickPlacement: 'between',
          categories: newData3,
          // title: {
      
          axisBorder: {
            show: true,
            color: "#78909C",
            offsetX: 0,
            offsetY: 0,
          },
        },
        tooltip: {
          enabled: true,
          intersect: true,
          shared: false,
        //   custom: function ({ dataPointIndex }) {
        //      var dateandtime =''
        //      self.paramLeaningProcess.timeType===self.byYear?dateandtime =moment(
        //       newData3.find((element, index) => index === dataPointIndex),
        //       "MM/YYYY"
        //     ).format("YYYY/MM"): dateandtime =moment(
        //       newData3.find((element, index) => index === dataPointIndex),
        //       "DD/MM/YYYY"
        //     ).format("YYYY/MM/DD")
        //     // if (self.yesterday !==  dateandtime ){
        //       self
        //         .actionGetDetailProcessLearningByDate({
        //           classId: self.classId,
        //           type: self.paramLeaningProcess.type,
        //           subjectId: self.paramLeaningProcess.subjectId,
        //           dateSelect: dateandtime,
        //           timeType: self.paramLeaningProcess.timeType,
        //           keyword: "",
        //           pageIndex: 1,
        //           PageSize: 3,
        //           sort: "",
        //           direction: "",
        //         })
        //         .then((res) => {
        //           self.yesterday =dateandtime
        //           if(res && res.data && res.data.list){
        //               self.dataByDay = res.data.list;
        //           }
        //         });
        //     // }
        //     let result = "";
        //       // var contet = "";
        //     if (self.dataByDay && self.dataByDay.length > 0) {
        //       // contet = '<div class="arrow_box">' +
        //       // '<span class="primary-color-txt font-size-16 font-sanpro-semibold cursor-pointer ml-2 mt-2 mb-2">' +
        //       // newData3.find((element, index) => index === dataPointIndex) +
        //       // "</span>" 
        //       self.dataByDay.map((item) => {
        //         if( self.paramLeaningProcess.type === 1 ) {
        //          result+= `<div class="item"> 
        //           <a href="javascript:;" class="primary-color font-size-16 secondary-color-blue cursor-pointer ml-2 mt-2 display-block full-width">
        //           ${item.name }
        //           </a>
        //           <span class="primary-color-txt font-sanpro font-size-14 ml-2 mb-2">
        //             ${ self.hhmmss(item.timeToDo )}
        //           </span>
        //           </div>`
        //         }else{
        //           result+= `<div class="item item-test">
        //           <a href="javascript:;" id="${item.name}" class="primary-color font-size-16 secondary-color-blue cursor-pointer ml-2 mt-2 display-block full-width"> 
        //            ${item.name } 
        //           </a>
        //           <span class="primary-color-txt font-sanpro font-size-14 ml-2 mb-2">
        //             ${ self.hhmmss(item.timeToDo )} -
        //           </span>
        //           <span class="primary-color-txt font-sanpro font-size-14">
        //             Làm đúng
        //             ${item.totalQuestionCorrect }/${item.totalQuestionDone }
        //           </span>
        //           </div>`
        //         }
        //       });
        //     }else{
        //       result = 
        //      `<div class="arrow_box">
        //       <div class="item1 secondary-color-txt text-center">Chưa có hoạt động nào</div>
        //       </div>`
        //     }
        //     return (
        //      self.template=  `<div class="arrow_box"> <span class="primary-color-txt font-size-16 font-sanpro-semibold cursor-pointer ml-2 mt-2 mb-2">
        //        ${newData3.find((element, index) => index === dataPointIndex) }

        //       </span> 
        //       ${result} 
        //       </div>`
        //     );
        //   },
         
        },
      };
    },
    pageRote(item){
      // console.log('paramLeaningProcess',this.paramLeaningProcess);
      if(this.paramLeaningProcess.type ===1){
        this.$router.push({
            name: "ebook-detail",
            params: {
              slug: item.slug,
              id: item.bookId,
            },
        });
      }else{
          // this.$router.push({
          //   name: "exerciseDetail",
          //   params: { id: item.bookId },
          //   query: { danhmuc: item.bookIndexId, cauhoi: item.questionDoneId },
          // })
    switch (item.typePractice) {
        case TYPE_READ_BOOK_ACTIVITY:
          this.$router.push({
            name: "ebook-read-book",
            params: { id: item.bookId, slug: item.slug },
            query: { page: item.pageNo },
          });
          break;
        case TYPE_EXERCISE_ACTIVITY:
          this.$router.push({
            name: "exerciseDetail",
            params: { id: item.bookId },
            query: { danhmuc: item.bookIndexId, cauhoi: item.questionDoneId },
          });
          break;
        case TYPE_ACTIVE_ACTIVITY:
          this.$router.push({
            name: "ebook-detail",
            params: { id: item.bookId, slug: item.slug },
          });
          break;
        case TYPE_EXERCISE_ACTIVITY_EXAM:
          this.$router.push({
            name: "exerciseExamQuestion",
            params: {
              classId: item.classId,
              subjectId: item.subjectId,
              typeId: 9,
              id: item.examId,
            },
            query: {
              cauhoi: item.questionDoneId
            }
          })
          break;
        case TYPE_EXERCISE_ACTIVITY_THEMATIC:
          this.$router.push({
            name: "exerciseThematicDetail",
            params: {
              classId: item.classId,
              subjectId: item.subjectId,
              typeId: 8,
              id: item.chapterId,
            },
            query: {
              cauhoi: item.questionDoneId
            }
          });
          break;
        case TYPE_EXERCISE_ACTIVITY_OTHER:
          this.$router.push({
            name: "exerciseOtherDetail",
            params: {
              classId: item.classId,
              subjectId: item.subjectId,
              typeId: 1,
              id: item.chapterId,
            },
            query: {
              cauhoi: item.questionDoneId
            }
          });
          break;
      }
      }
    },
    updateChartCount() {
      if (this.dataOverSubjectChart && this.dataOverSubjectChart.length > 0) {
        this.dataOverSubjectChart.map((item) => {
          this.seriesBar[0].data.push(Math.round(item.averageScore));
        });
      }
      const newData = this.seriesBar[0].data;
      this.seriesBar = [
        {
          data: newData,
          name: "Điểm",
        },
      ];
    },
    updateChartSubject() {
      if (this.dataOverSubjectChart && this.dataOverSubjectChart.length > 0) {
        this.dataOverSubjectChart.map((item, index) => {
          this.chartOptionsBar.xaxis.categories.push(item.name);
        });
      }
      const newData = this.chartOptionsBar.xaxis.categories;
      this.chartOptionsBar = {
        xaxis: {
          categories: newData,
        },
      };
    },
    handelDataListProcessLearing() {
      this.series[0].data = [];
      this.chartOptions.xaxis.categories = [];
      this.updateChart1();
      this.updateChart();
    },
    changeOverSubjectChart() {
      this.seriesBar[0].data = [];
      (this.chartOptionsBar.xaxis.categories = []), this.updateChartCount();
      this.updateChartSubject();
    },
    getOverviewSubjectChart() {
      this.actionGetOverviewSubjectChart({ classId: this.classId });
    },
    changePramPracticeChart() {
      this.actionGetProcessPracticeChart(this.pramPracticeChart);
    },
    changeParamLeaningProcess() {
      this.actionGetListProcessLearning(this.paramLeaningProcess);
    },
    getTypePractice() {
      this.actionGetTypePractice();
    },

    getSubjects() {
      this.actionGetSubjects({ classId: this.classId });
    },
    handleShowTableStatitic() {
      this.modalShow = false
      window.scrollTo(0, 0);
      this.isShowTableStatistic = true;
      this.isHideTable = false;
    },
    handleBackTime() {
      this.isHideTable = true;
      this.isShowTableStatistic = false;
    },
    pad(num) {
      return ("0"+num).slice(-2);
    },
    hhmmss(minutes) {
      alert
      var hours = Math.floor(minutes/60)
      minutes = minutes%60;
      return `${this.pad(hours)}:${this.pad(minutes)}:00`;
    },
    // updateChart2() {
    //   var a = this.chartOptions.xaxis.categories
    //    let self = this;
    //     this.chartOptions.tooltip = {
    //       custom:  function({  dataPointIndex} ) {

    //         moment(a.find((element,index) => index === dataPointIndex), 'DD/MM/YYYY').format('YYYY/MM/DD')
    //         self.actionGetDetailProcessLearningByDate({classId:self.classId,type:self.paramLeaningProcess.type,subjectId:self.paramLeaningProcess.subjectId,dateSelect:  moment(a.find((element,index) => index === dataPointIndex), 'DD/MM/YYYY').format('YYYY/MM/DD'),keyword:'',pageIndex:1,PageSize:10,sort:'',direction:''})
    //         .then(res=>{
    //           self.dataByDay =res.data.list;
    //         })
    //           var rest='';
    //           if( self.dataByDay &&  self.dataByDay.length >0){
    //                           self.dataByDay.map(item=>{
    //             rest +=
    //           '<div class="item">'+
    //             '<h4 class="primary-color font-size-16 font-sanpro-semibold cursor-pointer ml-2 mt-2"  onclick="alert(1)">'+item.name +'</h4>'+
    //             '<span class="primary-color-txt font-sanpro font-size-14 ml-2 mb-2">'+item.timeToDo+'</span>'+ '-' +'<span class="primary-color-txt font-sanpro font-size-14">'+'Làm đúng'+ ' '+item.totalQuestionCorrect+'/'+item.totalQuestion+'</span>'
    //           '</div>'
    //           })
    //           }
    //             return (
    //             ' <div class="arrow_box">'+
    //             '<span class="primary-color font-size-16 font-sanpro-semibold cursor-pointer ml-2 mt-2 mb-2">'+a.find((element,index) => index === dataPointIndex)+'</span>'+
    //                     rest+
    //             '</div>'
    //             );
    //           }
    //   }
    // },
    showDetailChart (chart,e) {
      this.clientX = (chart.pageX-60) +'px'
      this.clientY = (chart.pageY-7)+'px'
      this.modalShow = true
          this.paramLeaningProcess.timeType===self.byYear?this.dateandtime =moment(
              this.chartOptions.xaxis.categories.find((element, index) => index === e.dataPointIndex),
              "MM/YYYY"
            ).format("YYYY/MM"): this.dateandtime =moment(
              this.chartOptions.xaxis.categories.find((element, index) => index === e.dataPointIndex),
              "DD/MM/YYYY"
            ).format("YYYY/MM/DD")
                if(this.dateandtime !=='Invalid date'){
                  this.actionGetDetailProcessLearningByDate({
                    classId: this.classId,
                    type: this.paramLeaningProcess.type,
                    subjectId: this.paramLeaningProcess.subjectId,
                    dateSelect: this.dateandtime,
                    timeType: this.paramLeaningProcess.timeType,
                    keyword: "",
                    pageIndex: 1,
                    PageSize: 3,
                    sort: "",
                    direction: "",
                  })
                  .then((res) => {
                    if(res && res.data && res.data.list){
                        this.dataByDay = res.data.list;
                    }
                  })
                }
    },
  },
};
</script>

<style lang="scss" scoped>
.arrow_box{
z-index: 99999999999999999999999;
position: absolute;
    width: 350px !important;
    // padding-top: 15px !important;
    // padding-bottom: 15px !important;
    background: #fff;
    border-radius: 8px;
    border: 1px solid #eaeaea;
}
.all-select {
  select {
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    display: block;
    text-overflow: ellipsis;
    max-height: 57.6px;
    line-height: 28.8px;
    padding: 0 30px 0 15px !important;
  }
}
.primary-color {
  color: #0f3dba !important;
  cursor: pointer !important;
}
.arrow_box {
  width: 300px !important;
  .item {
    border: 1px solid #eaeaea;
  }
}
.table thead th {
  border: none !important;
  color: #40505e !important;
  font-family: sandisplaypro-bold;
}
.table td,
.table th {
  padding: 0.75rem;
  vertical-align: top;
  border-top: 1px solid #dee2e6;
  border-bottom: 1px solid #dee2e6;
  // font-size: 15px;
}
.title-table {
}
.mt-43 {
  margin-top: 43px;
}
.border-css {
  border: 1px solid #eaeaea;
  border-radius: 16px;
  overflow: hidden;
}
.learn-process {
  padding-bottom: 100px;
  &__excercise {
    // border: 1px solid #eaeaea;
    // border-radius: 16px;
    // overflow: hidden;
    // padding: 17px;
    .title {
      margin-bottom: 25px;
      padding: 17px 17px 0 17px;
    }
    .all-select {
      margin-bottom: 35px;
      padding-left: 17px;
    }
    .result {
      width: 30%;
      padding-left: 17px;
    }
    .target {
      position: absolute;
      right: 50px;
      top: 17px;
      img {
        width: 130px;
      }
      .target-name {
        margin-top: 15px;
      }
    }
    .score-chart {
      margin-top: 20px;
      .bg-chart {
        width: 100%;
      }
      .line {
        position: absolute;
        bottom: 0;
        width: 100%;
        height: 32px;
        .bg-success {
          background: red;
        }
        .img-line {
          width: 100%;
        }
      }
      .student {
        position: absolute;
        bottom: 30px;
        // left: 24%;
      }
      .flag {
        position: absolute;
        bottom: 30px;
        right: 18px;
      }
    }
  }
  &__study {
    padding: 17px;
    .title {
      margin-bottom: 25px;
    }
    .all-select {
      margin-bottom: 20px;
    }
  }
  &__overview {
    padding: 17px;
    .chart {
      margin-top: 20px;
    }
  }
}
.table-learn-process {
  margin-top: 25px;
}
.table-statistic {
  &__back-time {
    margin-bottom: 15px;
    .back-text {
      &:hover {
        color: #0f3dba;
      }
    }
  }
}
.select-custom {
  width: 180px;
  margin-right: 20px;
  i {
    color: #0f3dba;
  }
}
.select-custom select {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  line-height: 20px;
  border-radius: 20px;
  height: 30px;
  background: #f3f6fb;
  border: 0;
}

@media screen and (max-width: 1024px) {
  .learn-process__excercise {
    .result {
      width: 60%;
    }
    .all-select {
      margin-bottom: 15px;
    }
    .target img {
      width: 110px;
    }
    .score-chart {
      .flag,
      .student {
        bottom: 17px;
      }
      .img-student,
      .img-flag {
        height: 85px;
      }
    }
    .select-custom {
      width: 150px;
    }
  }
}
@media screen and (max-width: 575px) {
  .learn-process__excercise {
    .all-select {
      display: block !important;
      margin-top: 30px;
      padding: 0 17px;
      .select-custom {
        width: 100%;
        margin-bottom: 15px;
      }
    }
    .target {
      position: unset;
      text-align: center;
    }
    .score-chart {
      margin-top: 70px;
      .flag,
      .student {
        bottom: 10px;
      }
      .img-student,
      .img-flag {
        height: 50px;
      }
      .line {
        bottom: -5px;
      }
    }
  }
  .learn-process__study {
    .all-select {
      display: block;
    }
    .select-custom {
      width: 100%;
      margin-bottom: 15px;
    }
  }
  .table-list table {
    max-width: 100%;
  }
  .table-list table th {
    /*width: 700px;*/
    display: none;
  }
  .table-list table tr {
    border: 1px solid #dee2e6;
    padding: 15px;
    display: block;
  }
  .table-list table td {
    display: block;
    width: 100%;
    text-align: center !important;
    padding: 0;
    border: 0;
  }
  .table-list table td:before {
    content: attr(data-label);
    display: inline-block;
    font-weight: bold;
    margin-right: 8px;
    color: #40505e;
    font-weight: 500;
  }
  .table-statistic {
    .all-select {
      display: block;
    }
    .select-custom {
      width: 100%;
      margin-bottom: 15px;
    }
  }
}
@media screen and (max-width: 425px) {
  .learn-process__excercise {
    .select-custom {
      width: 230px;
      margin-bottom: 15px;
    }
    .target {
      right: 15px;
      text-align: center;
    }
    .result {
      width: 100%;
      padding: 0 17px;
    }
  }
  .learn-process__study {
    .select-custom {
      width: 100%;
      margin-bottom: 15px;
    }
  }
}
</style>